import { FC } from 'react';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

export const Tooltip: FC<TooltipProps> = (props) => <MuiTooltip {...props} />;

export default Tooltip;
